import React, { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { CPENZLoader } from "@/components/CPENZLoader";

// Letters finish surfacing at (0.35 + 7*0.2 + 1.6)/SPEED s: the veil waits for the full wordmark before revealing the page
const SPEED = 2.2;
const LOADER_MS = Math.round(((0.35 + 7 * 0.2 + 1.6) / SPEED) * 1000) + 80;

/** Entry loading veil (once per session): white screen, the black cpenz wordmark slowly surfaces, then the app fades in. */
export default function PageLoader() {
  const [show, setShow] = useState(() => { try { return !window.sessionStorage.getItem("cpenz_entered"); } catch { return false; } });
  const reduce = useReducedMotion();

  // Only on the first entry into the web app (not between pages). The timer is re-armed (never orphaned) if the effect re-runs.
  useEffect(() => {
    if (!show) return undefined;
    try { window.sessionStorage.setItem("cpenz_entered", "1"); } catch {}
    const t = setTimeout(() => setShow(false), reduce ? 200 : LOADER_MS);
    const safety = setTimeout(() => setShow(false), LOADER_MS + 1500);
    return () => { clearTimeout(t); clearTimeout(safety); };
  }, [show, reduce]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="page-loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] bg-white flex items-center justify-center"
          data-testid="page-loader"
        >
          <CPENZLoader size={120} speed={SPEED} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
